/**
 * CurrencyInput — Formats a text input to 2 decimal places on blur.
 *
 * Usage: <input type="text" inputmode="decimal" phx-hook="CurrencyInput" />
 */
const CurrencyInput = {
  mounted(this: any) {
    this.el.addEventListener("blur", () => this.formatValue());
  },

  formatValue(this: any) {
    const val = parseFloat(this.el.value);

    if (!isNaN(val)) {
      this.el.value = val.toFixed(2);
    }
  },
};

export default CurrencyInput;
